var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { loadScript } from "../../../utils/loadScriptNoCache";
// 初始化Google client
var initGoogleClient = function () {
    return new Promise(function (resolve, reject) {
        window.gapi.load("client", function () {
            window.gapi.client
                .init({
                // 个人申请的client_id，申请地址：https://console.cloud.google.com/apis/dashboard
                client_id: "1027429869615-22kkb487knhbbl72rh4u3iq01ajhs8ij.apps.googleusercontent.com",
            })
                .then(function () {
                resolve(true);
            }, function () {
                reject("Google client初始化失败");
            });
        });
    });
};
// 初始化Youtube api
var initYoutubeApi = function () {
    return new Promise(function (resolve, reject) {
        // 个人申请的api_key，申请地址：https://console.cloud.google.com/apis/dashboard
        window.gapi.client.setApiKey("AIzaSyDTzeUH0S9A7cVJudGgpn3pFQEIxxBCZcw");
        window.gapi.client
            .load("https://www.googleapis.com/discovery/v1/apis/youtube/v3/rest")
            .then(function () {
            resolve(true);
        }, function () {
            reject("Youtube api初始化失败");
        });
    });
};
// 获取YouTube 视频信息
var getVideoInfo = function (id, part) {
    return new Promise(function (resolve, reject) {
        window.gapi.client.youtube.videos
            .list({
            part: part,
            id: id, // 可以传入多个例如:['a', 'b']
        })
            .then(function (res) {
            resolve(res);
        }, function () {
            reject("获取视频失败");
        });
    });
};
var initResolver;
var initLocker = false;
var initPromise = new Promise(function (resolve) {
    initResolver = resolve;
});
/**
 * @author xiepengfei.alpaca
 * @date 2023-02-23 11:20:00
 * @desc 提供先行初始化的方法，因为初始化整个过程比较耗时（5s左右），
 * 所以可以在使用的时候先进行初始化，获取视频信息直接调用getYoutubeVideoInfo，优化调用时间。
 */
export var youtubeVideoInfoInit = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (initLocker) {
                    return [2 /*return*/];
                }
                initLocker = true;
                if (!!window.gapi) return [3 /*break*/, 2];
                return [4 /*yield*/, loadScript("https://apis.google.com/js/api.js", function () {
                        return !!window.gapi;
                    })];
            case 1:
                _a.sent();
                _a.label = 2;
            case 2:
                if (!!window["__g_y_i_s__"]) return [3 /*break*/, 5];
                return [4 /*yield*/, initGoogleClient()];
            case 3:
                _a.sent();
                return [4 /*yield*/, initYoutubeApi()];
            case 4:
                _a.sent();
                window["__g_y_i_s__"] = true;
                _a.label = 5;
            case 5:
                initResolver(true);
                return [2 /*return*/];
        }
    });
}); };
/**
 * @author xiepengfei.alpaca
 * @date 2023-02-22 17:18:00
 * @desc 通过youtube 链接/id 获取视频信息，例如播放量、作者、点赞数等等
 * @param VideoInfo
 */
export var getYoutubeVideoInfo = function (options) { return __awaiter(void 0, void 0, void 0, function () {
    var id, _a, part, res_1, _id, regex, match, regex, match, regex, match, res, data;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                id = options.id, _a = options.part, part = _a === void 0 ? ["snippet,contentDetails,id,statistics"] : _a;
                if (!id) {
                    throw { code: -1, message: "id参数不能为空" };
                }
                if (Array.isArray(id) && id.length === 0) {
                    throw { code: -2, message: "id数组长度不能为0" };
                }
                // 等待初始化sdk
                youtubeVideoInfoInit();
                return [4 /*yield*/, initPromise];
            case 1:
                _b.sent();
                if (!Array.isArray(id)) return [3 /*break*/, 3];
                return [4 /*yield*/, getVideoInfo(id, part)];
            case 2:
                res_1 = _b.sent();
                return [2 /*return*/, res_1.result];
            case 3:
                _id = null;
                // 复制浏览器上YouTube的网址: https://www.youtube.com/watch?v=Dvh3_A5JhXY
                // 复制分享的短链网址: https://youtu.be/Dvh3_A5JhXY
                // 复制分享的直播网址: https://www.youtube.com/live/PG-pnvXUvKM?feature=share
                // 复制ID: gOcQP_Gi9r8
                if (id.indexOf("watch") > -1) {
                    regex = /v=([^\&]{11})/;
                    match = id.match(regex);
                    if (match) {
                        _id = match[1];
                    }
                }
                else if (id.indexOf("youtu.be") > -1) {
                    regex = /youtu\.be\/([^\&]{11})/;
                    match = id.match(regex);
                    if (match) {
                        _id = match[1];
                    }
                }
                else if (id.indexOf("live") > -1) {
                    regex = /live\/([^\?]+)/;
                    match = id.match(regex);
                    if (match) {
                        _id = match[1];
                    }
                }
                else {
                    // 默认ID
                    _id = id;
                }
                if (!_id) {
                    throw { code: -3, message: "链接格式有误" };
                }
                return [4 /*yield*/, getVideoInfo([_id], part)];
            case 4:
                res = _b.sent();
                data = res.result.items[0];
                if (!data) {
                    throw { code: -4, message: "无数据" };
                }
                return [2 /*return*/, data];
        }
    });
}); };
//# sourceMappingURL=youtubeApi.js.map